export default __webpack_public_path__ + "static/media/Lightning.49944dd9.svg";